import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const FarmerDetails = ({ farmer,  darkMode }) => {
  const [selectedFarmer, setSelectedFarmer] = useState(farmer || null);

  useEffect(() => {
    setSelectedFarmer(farmer);
  }, [farmer]);

  return (
    <DetailsWrapper darkMode={darkMode}>
      <LineTop  darkMode={darkMode}/>
      <Header darkMode={darkMode}>
        <Title darkMode={darkMode}>Farmer Details</Title>
      </Header>
      <DetailsContainer darkMode={darkMode}>
        {selectedFarmer ? (
          <>
         <DetailsGrid>
  <Label darkMode={darkMode}>ID:</Label><Value darkMode={darkMode}>{selectedFarmer.id}</Value>
  <Label darkMode={darkMode}>Name:</Label><Value darkMode={darkMode}>{selectedFarmer.name}</Value>
  <Label darkMode={darkMode}>Status:</Label><Value darkMode={darkMode}>Active</Value>
  <Label darkMode={darkMode}>System:</Label><Value darkMode={darkMode}>Malinao</Value>
  <Label darkMode={darkMode}>Name of IA:</Label><Value darkMode={darkMode}>Unknown</Value>
</DetailsGrid>

          </>
        ) : (
          <Message darkMode={darkMode}>No farmer selected. Please choose a farmer to view details.</Message>
        )}
      </DetailsContainer>
    </DetailsWrapper>
  );
};

export default FarmerDetails;

const DetailsWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 500px;
background-color: ${({ darkMode }) => (darkMode ? 'rgb(227, 236, 234)' : 'rgb(1, 110, 16)')};
  border: 2px solid #ccc; 
  border-radius: 12px;
  padding: 10px;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); 
`;

const LineTop = styled.div`
  position: absolute;
  top: 0;
  left: 10;
  right: 0;
  height: 2px;
  background-color: ${({ darkMode }) => (darkMode ? '#ccc' : 'rgb(1, 110, 78)')};
`;

const Header = styled.div`
  display: inline-block;
  height: 16%;
  position: absolute;
  top: -15px;
  left: 20px;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(1, 110, 78)' : 'rgb(252, 249, 249)')};
  padding: 0 8px;
`;

const Title = styled.h2`
  font-size: 1rem;
  color: ${({ darkMode }) => (darkMode ? ' #f2f2f2' : '#333')};
  font-weight: 600;
  margin: 0;
`;

const DetailsContainer = styled.div`
  padding-top: 0px;
  padding: 10px;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(1, 110, 77)' : '#f9f9f9')};
  min-height: 200px;
`;

const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  row-gap: 15px;
  column-gap: 10px;
  padding: 10px 0;
`;

const Label = styled.div`
  font-weight: bold;
 color: ${({ darkMode }) => (darkMode ? ' #f2f2f2' : '#333')};
`;

const Value = styled.div`
  color: ${({ darkMode }) => (darkMode ? ' #f2f2f2' : '#333')};
`;

const Message = styled.div`
  margin-top: 10px;
  color: ${({ darkMode }) => (darkMode ? ' #f2f2f2' : '#333')};
  font-size: 16px;
`;
